import React from 'react'
import {
  Consumer as AdminContextConsumer,
  Provider as AdminContextProvider,
} from './admin-context'

const withDummyWrapper = WrappedLazyComponent => {
  return class extends React.PureComponent {
    state = {
      server: true,
    }

    componentDidMount() {
      this.setState({ server: false })
    }

    _defaultRender() {
      const { defaultRender, children } = this.props
      if (defaultRender) {
        return defaultRender()
      }
      return children
    }

    render() {
      const { server } = this.state
      return (
        <AdminContextConsumer>
          {isAdmin =>
            server || !isAdmin ? (
              <React.Fragment>{this._defaultRender()}</React.Fragment>
            ) : (
              <React.Suspense fallback={<div />}>
                <WrappedLazyComponent {...this.props}>
                  {this.props.children}
                </WrappedLazyComponent>
              </React.Suspense>
            )
          }
        </AdminContextConsumer>
      )
    }
  }
}

const DnDContext = withDummyWrapper(
  React.lazy(() => import(/*webpackChunkName: "ui-builder"*/ './dnd-context'))
)

const GenericStoreProvider = withDummyWrapper(
  React.lazy(() =>
    import(/*webpackChunkName: "ui-builder"*/ './generic-provider')
  )
)

export {
  withDummyWrapper,
  DnDContext,
  AdminContextProvider,
  AdminContextConsumer,
  GenericStoreProvider,
}
